module.exports = __webpack_public_path__ + "static/media/alternative_3_big@x2.d44bcf8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/alternative_3_big@x2.png
// module id = 540
// module chunks = 0